/**
 * Her mic, drawn where the camera tile was (D29 dropped video): she always
 * sees whether her mic is live. Outside a take it says, quietly, that it is
 * off; while taken it says he hears her and shows her level. A problem is
 * words and a button, never a colour alone.
 */
import { useEffect, useState, useSyncExternalStore } from "react";

import { Level } from "./Level";
import { ChildVoice, exposeForTests } from "./child";

import "./voice.css";

export function ChildVoiceIndicator({ taken }: { taken: boolean }) {
  const [voice] = useState(() => new ChildVoice());
  useEffect(() => {
    exposeForTests(voice);
    voice.start();
    return () => voice.destroy();
  }, [voice]);
  useEffect(() => {
    voice.setTaken(taken);
  }, [voice, taken]);
  const v = useSyncExternalStore(voice.subscribe, voice.getSnapshot);

  if (v.conn === "off") return null; // no voice on this server: nothing to show
  const live = v.mic === "live";
  return (
    <div className="voice" data-voice data-mic={v.mic} data-conn={v.conn}>
      <span className={`voice-mic ${live ? "live" : ""}`} aria-live="polite">
        <span className="vglyph" aria-hidden>
          🎙
        </span>
        {live ? (
          <>
            {v.tutorHere ? "Mikrofonas įjungtas: mokytojas tave girdi" : "Mikrofonas įjungtas, mokytojas jungiasi…"}
            <Level read={() => voice.levels().me} label="Tavo mikrofonas" />
          </>
        ) : v.mic === "starting" ? (
          "Įjungiamas mikrofonas…"
        ) : (
          "Mikrofonas išjungtas"
        )}
      </span>
      {v.taken && v.mic === "problem" && v.problem && (
        <span className="voice-note">
          {v.problem}{" "}
          <button type="button" className="quiet-link" onClick={() => voice.retryMic()} data-act="voice-retry">
            Bandyti dar kartą
          </button>
        </span>
      )}
      {v.taken && v.audioBlocked && (
        <button type="button" className="btn btn-quiet" onClick={() => voice.unlockAudio()} data-act="voice-unlock">
          Įjungti garsą
        </button>
      )}
      {v.taken && live && v.devices.length > 1 && (
        <select className="voice-note" value={v.device ?? ""} onChange={(e) => void voice.setDevice(e.target.value)} aria-label="Mikrofonas">
          {!v.device && <option value="">numatytasis</option>}
          {v.devices.map((d) => (
            <option key={d.id} value={d.id}>
              {d.label}
            </option>
          ))}
        </select>
      )}
      {v.conn === "replaced" && <span className="voice-note">Garsas atidarytas kitame lange.</span>}
      {v.taken && (v.conn === "reconnecting" || v.conn === "retrying") && <span className="voice-note">Ryšys trūkinėja, jungiamasi…</span>}
    </div>
  );
}
